// extracted by mini-css-extract-plugin
export default {"footerBg":"m-z","footerTopLinks":"n-z","footerFeedback":"o-z","footerSocial":"p-z","footerLegalLinks":"q-z","footerIconCards":"r-z","footerBotCopy":"s-z"};